// Global customizer functions
window.parseCustomizerSelections = function() {
  //console.log('🔧 parseCustomizerSelections çalışıyor...');
  
  // Ana customizer detayları
  const customizerElements = document.querySelectorAll('.cart-items__customizer');
  //console.log('📋 Bulunan customizer elements:', customizerElements.length);
  
  customizerElements.forEach((element, index) => {
    const selections = element.getAttribute('data-selections');
    //console.log(`📦 Element ${index} selections:`, selections);
    
    if (selections) {
      try {
        const data = JSON.parse(selections);
        
      } catch (error) {
        console.log(error);
      }
    }
  });
  
  // Başlık genişlik bilgileri
  const titleCustomizerElements = document.querySelectorAll('.cart-items__title-customizer');
  //console.log('📋 Bulunan title customizer elements:', titleCustomizerElements.length);
  
  titleCustomizerElements.forEach((element, index) => {
    const selections = element.getAttribute('data-selections');
    if (selections) {
      try {
        const data = JSON.parse(selections);
        element.classList.remove('cart-items__title-customizer-loading');
      } catch (error) {
        //console.error('❌ Title JSON parse error:', error);
      }
    }
  });
};

document.addEventListener('DOMContentLoaded', function() {
  // console.log('🚀 DOM loaded, parseCustomizerSelections called...');
  window.parseCustomizerSelections();
});

if (document.readyState === 'complete') {
  console.log('⚡ Page is already loaded, parseCustomizerSelections now called...');
  window.parseCustomizerSelections();
}
